import { render, staticRenderFns } from "./MeituanFlashPurchase.vue?vue&type=template&id=2d410fa3&scoped=true&"
import script from "./MeituanFlashPurchase.vue?vue&type=script&lang=js&"
export * from "./MeituanFlashPurchase.vue?vue&type=script&lang=js&"
import style0 from "./MeituanFlashPurchase.vue?vue&type=style&index=0&id=2d410fa3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d410fa3",
  null
  
)

export default component.exports